export const GET_FAVORITES = "GET_FAVORITES";
export const GET_FAVORITES_SUCCESS = "GET_FAVORITES_SUCCESS";
export const GET_FAVORITES_FAIL = "GET_FAVORITES_FAIL";

export const ADD_FAVORITE = "ADD_FAVORITE";
export const ADD_FAVORITE_FAIL = "ADD_FAVORITE_FAIL";

const GET_FAVORITELAYOUT = "GET_FAVORITELAYOUT";
const GET_FAVORITELAYOUT_SUCCESS = "GET_FAVORITELAYOUT_SUCCESS";
const GET_FAVORITELAYOUT_FAIL = "GET_FAVORITELAYOUT_FAIL";

const DELETE_FAVORITE = "DELETE_FAVORITE";

const initialState = {
  data: [],
  layouts: [],
  loading: false,
  hasError: false,
  messageError: "",
  loadingFavorites: false,
};

export default function favorites(state = initialState, action) {
  switch (action.type) {
    case GET_FAVORITES: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_FAVORITES_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    }

    case GET_FAVORITES_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_FAVORITELAYOUT: {
      return {
        ...state,
        loadingFavorites: true,
      };
    }

    case GET_FAVORITELAYOUT_SUCCESS: {
      return {
        ...state,
        loadingFavorites: false,
        layouts: action.payload.data,
      };
    }

    case GET_FAVORITELAYOUT_FAIL: {
      return {
        ...state,
        loadingFavorites: false,
        hasError: true,
      };
    }

    default:
      return state;
  }
}

export function getFavorites() {
  return {
    type: GET_FAVORITES,
    payload: {
      request: {
        url: "Favorite",
      },
    },
  };
}

export function addFavorite(favorite) {
  return {
    type: ADD_FAVORITE,
    payload: {
      request: {
        url: "Favorite",
        method: "POST",
        data: favorite,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFavorites());
        },
      },
    },
  };
}

export function getFavoritesToLayout() {
  return {
    type: GET_FAVORITELAYOUT,
    payload: {
      request: {
        url: "Favorite/Layouts",
      },
    },
  };
}

export function deleteFavorite(id) {
  return {
    type: DELETE_FAVORITE,
    payload: {
      request: {
        url: "Favorite/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFavorites());
        },
      },
    },
  };
}
